import reducer from './reducer'

import * as signupOperations from './operations'
import * as signupSelectors from './selectors'

export { signupOperations, signupSelectors }

export default reducer
